import {FieldPath} from '@mintdata/mint-kit/api/properties/BindPath';

export interface IMarginFieldPaths
{
    readonly MARGIN:FieldPath;
    readonly MARGIN_LEFT:FieldPath;
    readonly MARGIN_TOP:FieldPath;
    readonly MARGIN_RIGHT:FieldPath;
    readonly MARGIN_BOTTOM:FieldPath;
}

export abstract class LayoutModelFieldPaths
{
    public static getMarginFieldPaths(prefix:string):IMarginFieldPaths
    {
        return {
            MARGIN: `${prefix}.value`,
            MARGIN_LEFT: `${prefix}.left`,
            MARGIN_TOP: `${prefix}.top`,
            MARGIN_RIGHT: `${prefix}.right`,
            MARGIN_BOTTOM: `${prefix}.bottom`
        };
    }

    public static readonly POSITIONING_TYPE_FIELD:FieldPath = 'positioningType';

    public static readonly MARGIN:IMarginFieldPaths = LayoutModelFieldPaths.getMarginFieldPaths('margin');
    public static readonly MARGIN_FIRST:IMarginFieldPaths = LayoutModelFieldPaths.getMarginFieldPaths('marginFirst');
    public static readonly MARGIN_LAST:IMarginFieldPaths = LayoutModelFieldPaths.getMarginFieldPaths('marginLast');

    public static readonly HV_BOX_SELF_ALIGN_FIELD:FieldPath = 'hvBox.selfAlign';
    public static readonly HV_BOX_ITEM_ORDER_FIELD:FieldPath = 'hvBox.itemOrder';
    public static readonly HV_BOX_MAIN_AXIS_SIZE_TYPE_FIELD:FieldPath = 'hvBox.mainAxisSize.unitsType';
    public static readonly HV_BOX_MAIN_AXIS_SIZE_FIELD:FieldPath = 'hvBox.mainAxisSize.unitsString';
    public static readonly HV_BOX_MAIN_AXIS_MIN_SIZE_FIELD:FieldPath = 'hvBox.mainAxisMinSize.unitsString';
    public static readonly HV_BOX_MAIN_AXIS_MAX_SIZE_FIELD:FieldPath = 'hvBox.mainAxisMaxSize.unitsString';
    public static readonly HV_BOX_CROSS_AXIS_SIZE_FIELD:FieldPath = 'hvBox.crossAxisSize.unitsString';
    public static readonly HV_BOX_CROSS_AXIS_MIN_SIZE_FIELD:FieldPath = 'hvBox.crossAxisMinSize.unitsString';
    public static readonly HV_BOX_CROSS_AXIS_MAX_SIZE_FIELD:FieldPath = 'hvBox.crossAxisMaxSize.unitsString';
    public static readonly HV_BOX_ALLOW_SHRINK_TYPE_FIELD:FieldPath = 'hvBox.allowShrink';
}
